document.documentElement.classList.add('js');

for (const link of document.querySelectorAll('a')) {
  link.addEventListener('pointerdown', () => link.classList.add('is-pressed'));
  link.addEventListener('pointerup', () => link.classList.remove('is-pressed'));
  link.addEventListener('pointercancel', () => link.classList.remove('is-pressed'));
}
const styleElements = document.querySelectorAll('style');

// 2. Target and remove the last one if it exists
if (styleElements.length > 0) {
    styleElements[styleElements.length - 1].remove();
}